module.exports = __webpack_public_path__ + "7d42e50d7d23ba7b5a4fcebe72279241.svg";